<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <retencion-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import RetencionShowData from "./RetencionShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "RetencionShow",
        components: {CrudShow, RetencionShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'cobrox.retencion.showing',
            }
        },
    }
</script>

